import { CreateFocusCss } from '../../../styles'
import { styles } from '../../../utilities'
import type { Tokens } from '../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      link: {
        background: 'none',
        border: 'none',
        borderRadius: 0,
        color: tokens.fontColorLink,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        letterSpacing: 'normal',
        lineHeight: 'inherit',
        padding: 0,
        margin: 0,
        textAlign: 'inherit',
        textDecoration: 'none',

        ...CreateFocusCss(tokens.focusOuter),

        '&:hover': {
          color: tokens.fontColorLinkHover,
          textDecoration: 'underline',
        },

        '&:active': {
          color: tokens.fontColorLinkActive,
          textDecoration: 'none',
        },

        '&:disabled': {
          color: tokens.fontColorDisabled,
          cursor: 'default',
          textDecoration: 'none',

          '&:hover': {
            color: tokens.fontColorDisabled,
            textDecoration: 'none',
          },
        },

        '&:visited': {
          color: tokens.fontColorLinkVisited,
        },

        '&:focus': {
          color: tokens.fontColorLinkHover,
        },
      },
    },

    subtle: {
      link: {
        color: tokens.fontColorLinkSubtle,

        '&:hover': {
          color: tokens.link.subtleHoverColor,
        },

        '&:active': {
          color: tokens.link.subtleActiveColor,
        },

        // Not in the specs
        '&:visited': {
          color: tokens.fontColorLinkVisitedSubtle,
        },

        '&:focus': {
          color: tokens.link.subtleHoverColor,
        },
      },
    },

    discrete: {
      textDecoration: 'inherit',
    },

    lightText: {
      color: tokens.link.lightColor,

      '&:hover': {
        color: tokens.fontColorLinkHover,
      },
    },

    hidden: styles.visuallyHidden,
  } as const
}
